import { FC } from "react";
import { Box, Text } from "@chakra-ui/react";
import { errorColor, successColor } from "../../../utils/colors";
import { borderRadius } from "../../../utils/styles/styles";

interface IndicatorManagementStateProps {
  stateValue: {
    id: number;
    name: string;
  };
  additionalStyle?: object;
}

const IndicatorManagementState: FC<IndicatorManagementStateProps> = ({
  stateValue,
  additionalStyle = {},
}) => {
  const getStateColor = () => {
    switch (stateValue?.id) {
      case 1:
        return successColor;
      case 2:
        return errorColor;
      case 3:
        return errorColor;
      default:
        return "gray.500";
    }
  };

  return (
    <Box
      fontWeight="bold"
      color={getStateColor()}
      mr="4"
      style={additionalStyle}
    >
      <Text
        border="1px solid"
        borderRadius={borderRadius}
        px="1"
        textTransform="uppercase"
        fontSize="sm"
      >
        {stateValue?.name}
      </Text>
    </Box>
  );
};

export default IndicatorManagementState;
